export default "/images/corner-right-down.svg?9e1bef80aab03d14798b77260f288a85";